import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/site/Layout";
import { ProtectedRoute } from "./pages/admin/ProtectedRoute";

import Home from "./pages/Home";
import Artists from "./pages/Artists";
import ArtistProfile from "./pages/ArtistProfile";
import Portfolio from "./pages/Portfolio";
import Styles from "./pages/Styles";
import StyleDetail from "./pages/StyleDetail";
import Studio from "./pages/Studio";
import Booking from "./pages/Booking";
import Faq from "./pages/Faq";
import LegalPage from "./pages/LegalPage";
import NotFound from "./pages/NotFound";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import AdminCalendar from "./pages/admin/AdminCalendar";
import AdminArtists from "./pages/admin/AdminArtists";
import AdminPortfolio from "./pages/admin/AdminPortfolio";
import AdminSettings from "./pages/admin/AdminSettings";

const Public = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={Public(<Home />)} />
          <Route path="/artists" element={Public(<Artists />)} />
          <Route path="/artists/:slug" element={Public(<ArtistProfile />)} />
          <Route path="/portfolio" element={Public(<Portfolio />)} />
          <Route path="/styles" element={Public(<Styles />)} />
          <Route path="/styles/:slug" element={Public(<StyleDetail />)} />
          <Route path="/studio" element={Public(<Studio />)} />
          <Route path="/about" element={Public(<Studio />)} />
          <Route path="/booking" element={Public(<Booking />)} />
          <Route path="/faq" element={Public(<Faq />)} />
          <Route path="/aftercare" element={Public(<LegalPage page="aftercare" />)} />
          <Route path="/policies" element={Public(<LegalPage page="policies" />)} />
          <Route path="/privacy" element={Public(<LegalPage page="privacy" />)} />
          <Route path="/terms" element={Public(<LegalPage page="terms" />)} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/bookings" element={<ProtectedRoute><AdminBookings /></ProtectedRoute>} />
          <Route path="/admin/submissions" element={<ProtectedRoute><AdminSubmissions /></ProtectedRoute>} />
          <Route path="/admin/calendar" element={<ProtectedRoute><AdminCalendar /></ProtectedRoute>} />
          <Route path="/admin/artists" element={<ProtectedRoute><AdminArtists /></ProtectedRoute>} />
          <Route path="/admin/portfolio" element={<ProtectedRoute><AdminPortfolio /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />

          <Route path="*" element={Public(<NotFound />)} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
